// extracted by mini-css-extract-plugin
export var columnItem = "_br-3";
export var columnItemDraggable = "_br-4";
export var dragHandle = "_br-0";
export var dragHandleHovered = "_br-1";
export var dropdown = "_br-5";
export var dropdownContent = "_br-7";
export var dropdownInner = "_br-6";
export var filterDropdownHeader = "_br-8";
export var icon = "_br-2";
export var sectionDivider = "_br-9";